/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * dashboard API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { GetV7DashboardsGroupParams, IntegrateDashboardGroupV7Response } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getGroups
 */
export const getV7DashboardsGroup = (
  params?: MaybeRef<GetV7DashboardsGroupParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<IntegrateDashboardGroupV7Response>(
    { url: `/api/v7/dashboards/group`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7DashboardsGroupQueryKey = (params?: MaybeRef<GetV7DashboardsGroupParams>) => {
  return ['api', 'v7', 'dashboards', 'group', ...(params ? [params] : [])] as const;
};

export const getGetV7DashboardsGroupQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7DashboardsGroup>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7DashboardsGroupParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7DashboardsGroup>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7DashboardsGroupQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7DashboardsGroup>>> = ({ signal }) =>
    getV7DashboardsGroup(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7DashboardsGroup>>,
    TError,
    TData
  >;
};

export type GetV7DashboardsGroupQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7DashboardsGroup>>
>;
export type GetV7DashboardsGroupQueryError = ErrorType<unknown>;

/**
 * @summary getGroups
 */

export function useGetV7DashboardsGroup<
  TData = Awaited<ReturnType<typeof getV7DashboardsGroup>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7DashboardsGroupParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7DashboardsGroup>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7DashboardsGroupQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
